export const MAX_PHOTOS = 6;
export const MAX_SUB_PHOTOS = 4;
